import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import DashboardHeader from "../dashboard/header/header";
import DashboardSidebar from "../dashboard/sidebar/sidebar";
import { Routes, Route } from "react-router-dom";
import Settings from "./settings/setting";
import Overview from "./overview/overview";
import Orders from "./orders/orders";
import OrderDetails from "./orders/order-details";
import TrackShipmentPage from "./orders/track-shippment";
import Addresses from "./addresses/addresses";
import Support from "./support/support";
import TransactionHistory from "./transactions/transactions";
import ReferralDashboard from "./referrals/ReferralDashboard";
// import SkinAnalysis from "./analysis/skin"

export default function DashboardLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <DashboardSidebar />
      <SidebarInset>
        <DashboardHeader />
        <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-6">
          <Routes>
            <Route path="overview" element={<Overview />} />
            <Route path="orders" element={<Orders />} />
            <Route path="orders/:orderId" element={<OrderDetails />} />
            <Route
              path="orders/track/:trackingId"
              element={<TrackShipmentPage />}
            />
            <Route path="addresses" element={<Addresses />} />
            <Route path="transactions" element={<TransactionHistory />} />
            {/* <Route path="analysis/skin" element={<SkinAnalysis />} /> */}
            <Route path="support" element={<Support />} />
            <Route path="referrals" element={<ReferralDashboard />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Overview />} />
            {/* Add more nested routes as needed */}
          </Routes>
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
